/* Grey Chapel — gc-product.js
   PDP variant picker, gallery carousel, sticky add-to-cart bar. See docs/gc-product.md. */
(function () {
  'use strict';
  var GC = window.GC;
  if (!GC) return;

  /* ---------------- Variant picker ---------------- */

  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    /* gallery carousel (scroll-snap track; thumbs and variant changes jump to a slide) */
    var track = section.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-slide]')) : [];

    function setActiveThumb(mediaId) {
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === mediaId);
      });
    }

    function goToSlide(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      setActiveThumb(slides[i].getAttribute('data-media-id'));
      markIndicator(i);
    }

    /* #x4d9s The hero's counter or dots follow the slide on screen. */
    var indicator = section.querySelector('[data-gallery-ind]');
    function markIndicator(i) {
      if (!indicator) return;
      var count = indicator.querySelector('[data-ind-count]');
      if (count) count.textContent = (i + 1) + '/' + slides.length;
      Array.prototype.forEach.call(indicator.querySelectorAll('[data-ind-dot]'), function (d, j) { d.classList.toggle('is-on', j === i); });
    }

    function slideIndexFor(featured) {
      if (!featured || !slides.length) return -1;
      var byId = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(featured.id); });
      if (byId !== -1) return byId;
      var src = featured.src || (featured.preview_image && featured.preview_image.src);
      if (!src) return -1;
      var name = src.split('?')[0].split('/').pop();
      return slides.findIndex(function (s) {
        var img = s.querySelector('img');
        return img && img.src.split('?')[0].indexOf(name) !== -1;
      });
    }

    var galleryScrolling = false;
    /* #q1v6b The counter follows the finger: once a swipe has moved 15% of a slide toward the next one it ticks, and ticks back if the swipe is abandoned. */
    var settled = track ? Math.round(track.scrollLeft / (track.clientWidth || 1)) : 0;
    var liveRaf = 0;
    function clearSlideZoom(slide) {
      slide.classList.remove('is-zooming');
      slide.style.backgroundSize = '';
      slide.style.backgroundImage = '';
    }
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        if (!liveRaf) liveRaf = requestAnimationFrame(function () {
          liveRaf = 0;
          var pos = track.scrollLeft / (track.clientWidth || 1);
          var live = pos > settled ? Math.ceil(pos - 0.15) : pos < settled ? Math.floor(pos + 0.15) : settled;
          markIndicator(Math.max(0, Math.min(live, slides.length - 1)));
        });
        if (!galleryScrolling) {
          galleryScrolling = true;
          slides.forEach(clearSlideZoom);
        }
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(settleGallery, 80);
      }, { passive: true });
      /* A finger resting mid-swipe stops the scroll events without ending the swipe, so the gallery only settles once the finger is up. */
      var touching = false;
      track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (t) {
        track.addEventListener(t, function () { touching = false; clearTimeout(scrollTimer); scrollTimer = setTimeout(settleGallery, 80); }, { passive: true });
      });
      var settleGallery = function () {
        if (touching) return;
        galleryScrolling = false;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        i = Math.max(0, Math.min(i, slides.length - 1));
        var slide = slides[i];
        if (slide) setActiveThumb(slide.getAttribute('data-media-id'));
        settled = i;
        markIndicator(i);
        syncColorToSlide(i);
      };
    }

    GC.emit('gallery:ready', { section: section, slides: slides, track: track, isScrolling: function () { return galleryScrolling; } });
    /* Button wording comes from the section settings; fall back to the shipped
       copy so a stale cached theme still renders something sensible. */
    var labels = {};
    try { labels = JSON.parse(section.getAttribute('data-labels') || '{}'); } catch (err) { labels = {}; }
    var L = {
      add: labels.add || 'Add to the Offering Plate',
      sticky: labels.sticky || 'Add',
      soldOut: labels.sold_out || 'Sold out',
      unavailable: labels.unavailable || 'Unavailable',
      select: labels.select || 'Select',
      showPrice: labels.show_price !== false
    };

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    var optionNames = (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : (o && o.name) || '';
    });

    /* First element per index wins, should an option row ever be rendered twice. */
    var hasOptionUI = !!section.querySelector('[data-option-index]');
    var selected = [];
    section.querySelectorAll('[data-option-index]').forEach(function (optEl) {
      var idx = parseInt(optEl.getAttribute('data-option-index'), 10);
      if (selected[idx] !== undefined && selected[idx] !== null) return;
      var sel = optEl.querySelector('.is-selected');
      selected[idx] = sel ? sel.getAttribute('data-option-value') : null;
    });

    var colorIdx = optionNames.findIndex(function (name) {
      return name.toLowerCase().indexOf('color') !== -1 || name.toLowerCase().indexOf('colour') !== -1;
    });
    var sizeIdx = optionNames.findIndex(function (name) { return name.toLowerCase().indexOf('size') !== -1; });

    /* Name of the first option still unchosen — only possible when preselection
       is turned off in Theme settings → Product options. */
    function missingOption() {
      if (!hasOptionUI) return null;
      for (var i = 0; i < optionNames.length; i++) {
        if (!selected[i]) return optionNames[i];
      }
      return null;
    }

    /* Mirror a pick across every copy of that option row. */
    function selectOption(idx, value) {
      section.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (optEl) {
        optEl.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-option-value') === value);
        });
        optEl.querySelectorAll('[data-option-label]').forEach(function (l) { l.textContent = value; });
      });
      selected[idx] = value;
    }

    /* Landing on a colour's mockup selects that colour. Slides not tied to a variant
       leave the selection alone. Per-section setting. */
    function syncColorToSlide(i) {
      if (colorIdx === -1 || !section.hasAttribute('data-sync-color')) return;
      /* data-color is stamped in Liquid from image->variant links and covers every
         linked image; featured images only find the first, so that is the fallback. */
      var value = slides[i] && slides[i].getAttribute('data-color');
      if (!value) {
        var variant = product.variants.find(function (v) {
          return slideIndexFor(v.featured_media || v.featured_image) === i;
        });
        if (!variant) return;
        value = variant.options[colorIdx];
      }
      if (!value || selected[colorIdx] === value) return;
      if (!section.querySelector('[data-option-index="' + colorIdx + '"]')) return;
      selectOption(colorIdx, value);
      update();
    }

    function findVariant() {
      return product.variants.find(function (v) {
        return selected.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    /* GC.money() is shared from module scope — the copy that lived here had a
       both-branches-identical currency ternary and produced the same string. */

    /* The sticky bar's selection line: "Black · L", or what is still to choose. */
    function summaryText(missing) {
      if (missing) return L.select + ' ' + missing.toLowerCase();
      var parts = [];
      for (var i = 0; i < optionNames.length; i++) {
        if (selected[i]) parts.push(selected[i]);
      }
      return parts.join(' · ');
    }

    function setBuyLabel(btn, variant) {
      /* The sticky button never carries the price — it sits in the detail line
         beside it, which leaves room for the full label. */
      if (btn.hasAttribute('data-sticky-btn')) { btn.textContent = L.sticky; return; }
      if (L.showPrice) {
        btn.innerHTML = esc(L.add) + ' • <span data-price-btn>' + GC.money(variant.price) + '</span>';
      } else {
        btn.textContent = L.add;
      }
    }

    /* #rs9fp The sticky thumbnail is the colour's own gallery slide at whatever width the slide already downloaded, so it never costs a request. */
    var stickyThumbSeq = 0;
    function setStickyThumb(variant) {
      stickyThumbFromSlide(variant ? slideIndexFor(variant.featured_media || variant.featured_image) : 0);
    }
    function stickyThumbFromSlide(i) {
      var thumb = section.querySelector('[data-sticky-thumb]');
      if (!thumb) return;
      var img = i !== -1 && slides[i] && slides[i].querySelector('img');
      if (!img) return;
      var seq = ++stickyThumbSeq;
      function put() {
        if (seq !== stickyThumbSeq) return;
        var src = img.currentSrc || img.src;
        if (thumb.src !== src) thumb.src = src;
        thumb.hidden = false;
      }
      if (GC.progressive.decoded(img)) put();
      else img.addEventListener('load', put, { once: true });
    }

    function update() {
      var missing = missingOption();
      var variant = missing ? null : findVariant();
      var idInput = section.querySelector('[data-variant-id]');

      section.querySelectorAll('[data-sticky-summary]').forEach(function (el) {
        el.textContent = summaryText(missing);
      });

      if (variant) {
        if (idInput) idInput.value = variant.id;
        section.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = GC.money(variant.price); });
        section.querySelectorAll('[data-add-btn]').forEach(function (btn) {
          btn.disabled = !variant.available;
          if (!variant.available) btn.textContent = L.soldOut;
          else setBuyLabel(btn, variant);
        });
        setStickyThumb(variant);
        var featured = variant.featured_media || variant.featured_image;
        if (featured) {
          var slideIdx = slideIndexFor(featured);
          if (slideIdx !== -1) goToSlide(slideIdx);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        section.querySelectorAll('[data-add-btn]').forEach(function (btn) {
          /* The sticky button stays live while options are outstanding — it
             opens the panel instead of submitting. */
          btn.disabled = !(missing && btn.hasAttribute('data-sticky-btn'));
          btn.textContent = missing ? (L.select + ' ' + missing.toLowerCase()) : L.unavailable;
        });
      }
    }

    section.addEventListener('click', function (e) {
      var valBtn = e.target.closest('[data-option-value]');
      if (!valBtn) return;
      e.preventDefault();
      var optEl = valBtn.closest('[data-option-index]');
      var idx = parseInt(optEl.getAttribute('data-option-index'), 10);
      selectOption(idx, valBtn.getAttribute('data-option-value'));
      if (idx === sizeIdx) GC.size.remember(valBtn.getAttribute('data-option-value'));
      update();
    });

    /* #s6q2m The shopper's last tapped size stands in for the preselected one, in any colour it is in stock. See docs/remembered-size.md. */
    (function applyRememberedSize() {
      if (sizeIdx === -1 || !section.querySelector('[data-option-index="' + sizeIdx + '"]')) return;
      var value = GC.size.match(GC.size.recall(), product.variants.map(function (v) { return v.options[sizeIdx]; }));
      if (!value) return;
      /* Already applied before paint by the inline script after the size row: only the sticky line and the URL are left to follow. */
      if (value === selected[sizeIdx]) { update(); return; }
      var want = selected.slice();
      want[sizeIdx] = value;
      var fits = product.variants.some(function (v) {
        return v.available && want.every(function (val, i) { return val === null || v.options[i] === val; });
      });
      if (!fits) return;
      selectOption(sizeIdx, value);
      update();
    })();

    /* gallery thumbs */
    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-media-id');
      var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === id; });
      if (i !== -1) { goToSlide(i); syncColorToSlide(i); }
    });

    /* #6j3oi Put the gallery on the variant the page was loaded with. Everything else about
       it is server-rendered and correct, but a scroll container always starts at
       zero, so ?variant= for a colour whose mockup is not first showed the right
       swatch above the wrong shirt. Instant, not smooth: this is where the gallery
       starts, and animating it reads as the page correcting itself. */
    (function positionGalleryOnLoad() {
      if (!track || slides.length < 2) return;
      var variant = missingOption() ? null : findVariant();
      var featured = variant && (variant.featured_media || variant.featured_image);
      if (!featured) return;
      var i = slideIndexFor(featured);
      if (i < 1) return;
      goToSlide(i, true);
      /* Again after layout settles: on a cold load the track can still measure zero,
         and a jump against zero width is a no-op that strands slide one. */
      requestAnimationFrame(function () { goToSlide(i, true); });
    })();

    /* #ocw6u The server always renders the real Add label against the variant it resolved.
       The prompt-to-choose state only means anything once the picker is interactive,
       so it goes on here — rendering it `disabled` in Liquid once let a theme-editor
       toggle hard-disable the only purchase path for a shopper with no JS. */
    var missing0 = missingOption();
    if (missing0) {
      section.querySelectorAll('[data-add-btn]').forEach(function (btn) {
        btn.disabled = !btn.hasAttribute('data-sticky-btn');
        btn.textContent = L.select + ' ' + missing0.toLowerCase();
      });
    }
    setStickyThumb(missing0 ? null : findVariant());
  }

  GC.register('[data-product]', initProduct);

  /* #g5r2m Delivery dates: today in Chicago plus the business-day range, weekends skipped. See docs/delivery-estimate.md. */
  function chicagoToday() {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
    var get = function (t) { return +parts.filter(function (x) { return x.type === t; })[0].value; };
    return new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
  }
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setUTCDate(r.getUTCDate() + 1); var w = r.getUTCDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function etaText(a, b) {
    var day = function (d) { return d.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }); };
    return a.getTime() === b.getTime() ? day(a) : day(a) + ' – ' + day(b);
  }
  GC.register('[data-eta]', function (el) {
    var out = el.querySelector('[data-eta-dates]');
    var min = parseInt(el.getAttribute('data-eta-min'), 10), max = parseInt(el.getAttribute('data-eta-max'), 10);
    if (!out || !(min > 0) || !(max >= min)) return;
    var today = chicagoToday();
    out.textContent = etaText(addBusinessDays(today, min), addBusinessDays(today, max));
  });
  GC.eta = { today: chicagoToday, add: addBusinessDays, text: etaText };

  /* #g4rd9 Gift card recipient: the fields are sent, and the email required, only while "send as a gift" is ticked. See docs/gift-cards.md. */
  GC.register('[data-giftto]', function (el) {
    var toggle = el.querySelector('[data-giftto-toggle]');
    if (!toggle) return;
    var fields = el.querySelectorAll('[data-giftto-field]');
    var offset = el.querySelector('[data-giftto-offset]');
    var date = el.querySelector('[data-giftto-date]');
    var iso = function (d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); };
    if (offset) offset.value = String(new Date().getTimezoneOffset());
    if (date) {
      var now = new Date();
      date.min = iso(now);
      date.max = iso(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 90));
    }
    function sync() {
      var on = toggle.checked;
      el.classList.toggle('is-on', on);
      fields.forEach(function (f) {
        f.disabled = !on;
        if (f.hasAttribute('data-giftto-required')) f.required = on;
      });
    }
    toggle.addEventListener('change', sync);
    sync();
  });
  /* ---------------- Mobile sticky Add to Cart ---------------- */

  /* #b5t9k Shown only while the real Add to Cart is off screen, above or below, and never over the footer. See docs/gc-product.md. */
  function initStickyAdd(section) {
    var bar = section.querySelector('[data-sticky-add]');
    var form = section.querySelector('[data-product-form]');
    var anchor = form && form.querySelector('[data-add-btn]');
    if (!bar || !form || !anchor || !('IntersectionObserver' in window)) return;

    /* Padding is applied once rather than toggled, so showing the bar never shifts the page under the thumb. */
    document.body.classList.add('gc-stickyadd-on');
    bar.removeAttribute('hidden');

    var addBtn = bar.querySelector('[data-sticky-btn]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var open = Array.prototype.filter.call(form.querySelectorAll('[data-option-index]'), function (o) {
          return !o.querySelector('.is-selected');
        })[0];
        if (open) { open.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    /* Up only once the real button has scrolled off the top, and it stays up to the end of the page: the body keeps room for it, which read as an empty band under the footer when the bar dropped away there. */
    var io = new IntersectionObserver(function (entries) {
      /* The editor replaces this section wholesale; a detached bar stops watching. */
      if (!bar.isConnected) { io.disconnect(); return; }
      var en = entries[entries.length - 1];
      var on = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.inert = !on;
    });
    io.observe(anchor);
    bar.inert = true;
  }

  GC.register('[data-product]', initStickyAdd);

  /* #r4m8s Details cover the pinned image: measures the lengths CSS cannot know. See docs/gc-product.md. */
  function initLift(section) {
    if (!window.ResizeObserver || !window.CSS || !CSS.supports('animation-timeline: scroll()')) return;
    var details = section.querySelector('.gc-pdp__details');
    var gallery = section.querySelector('.gc-pdp__gallery');
    if (!details || !gallery) return;
    var root = document.documentElement;
    var announce = document.querySelector('.gc-announce');
    var header = document.querySelector('.gc-header');
    var ro;
    /* The details column is never sticky, so its box is its flow position at any scroll. */
    function measure() {
      if (!details.isConnected) { ro.disconnect(); return; }
      // #q6z3p Unrounded: a whole-pixel pin a fraction off the resting top nudges the image on the first scroll and back at the top.
      var cover = details.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--gc-announce-h', (announce ? announce.getBoundingClientRect().height : 0) + 'px');
      root.style.setProperty('--pdp-cover', cover + 'px');
      root.style.setProperty('--pdp-gallery-top', (cover - gallery.getBoundingClientRect().height) + 'px');
    }
    ro = new ResizeObserver(measure);
    [announce, header, gallery, section.querySelector('.gc-crumbs')].forEach(function (el) { if (el) ro.observe(el); });
    measure();
    root.classList.add('gc-lift');
  }

  GC.register('.gc-pdp--lift', initLift);
})();
